<template>
  <v-textarea
    outlined
    v-bind="$attrs"
    :rules="required ? requiredRule : undefined"
    :value="value" 
    @input="v => $emit('input', v)"
    @blur="v => $emit('blur', v)"
    >
  </v-textarea>
</template>

<script>
export default {
  name: 'EsTextarea',
  props: {
    value: [String, Number],
    required: Boolean,
  },
  data: () => ({
    requiredRule: [
      (v) => !!v || 'Required',
    ],
  }),
};
</script>
